<mat-toolbar>
    <mat-toolbar-row class="justify-content-between">
      <div class="row mr-2 ml-auto">
        <ul>
          <li>
            <button mat-button class="user mt-2 mb-3 d-flex align-items-center">
              <img [src]="createImgPath(this.logoFile)" class="logo mr-1 p-2" />
            </button>
          </li>
        </ul>
      </div>
      <button mat-button class="user mt-1 mb-4 d-flex align-items-right">
        <img src="../../../assets/images/final automated.png" class="user-image mr-1 p-2" />
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

<div class="container">
   
        <h1>Your session has timeout! </h1>
        <h2>Your current browser session has expired due to inactivity.Please close the window and click the link in the email to enter your credit card information.</h2>
    
</div>

<app-footer></app-footer>